import { createAsyncThunk } from '@reduxjs/toolkit';
import { ServiceWidget } from '@services/ServiceWidget';
import { handleError, handleResponse, MyAxios } from '@services/SettingAxios';
import { ReturnFetchAvailabilityProductPromise } from '../types/availabilityProductSchema';
import { fetchAvailabilityProductDto } from './dto';

export const fetchAvailabilityProduct = createAsyncThunk<ReturnFetchAvailabilityProductPromise, fetchAvailabilityProductDto>(
  'availabilityProductSlice/fetchAvailabilityProduct',
  async ({ productRN, part, regionId }) => {
    const response = await MyAxios.get(`/api/products/${productRN}/availability?part=${part}&regionId=${regionId}`)
      .then(handleResponse)
      .catch(handleError);
    const shops = response?.pickUpAllShops;
    const dataWidget = !!shops?.length && (await ServiceWidget.getRecordShm(shops.map(x => x.shopId)));

    if (dataWidget) {
      for (let i = 0; i < shops?.length; i++) {
        const data = dataWidget.find(x => shops[i] && x?.shopId === shops[i]?.shopId);
        shops[i] = {
          ...shops[i],
          isLiveQueue: data?.liveQueue || false,
        };
      }
    }

    return { ...response, pickUpAllShops: shops };
  },
);
